module.exports = __webpack_public_path__ + "media/3.1ffeeaed.mp3";